import React, { createRef } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { Field, FormSection, reduxForm, formValueSelector } from 'redux-form';
import { get, isEmpty } from 'lodash';
import SwitchField from './switchField';
import AutocompleteSelectField from 'chameleon/ui-stack/ui/forms/autocomplete-select-field';
import {
  mapQuestionToSetting,
  truncate,
  pagePercentOptions,
  QUESTION_LINED_OPTIONS,
} from './utils';
import { getFieldOption } from 'chameleon-src/components/assign/AssignManageForm/utils';
import './index.scss';

const FRQPrintSetting = ({
  settingsFormState,
  questions,
  psMultipageFrqResponses,
}) => {
  const dropdownContainerRef = createRef();
  const PAGE_PERCENT_OPTIONS = pagePercentOptions(psMultipageFrqResponses);
  const dropdownRef = createRef();
  const containerRef = createRef();
  return (
    <div ref={containerRef} className="PrintSettings__settings-container">
      <ul className="PrintSettings__questions-list" ref={dropdownContainerRef}>
        {!isEmpty(settingsFormState) &&
          questions.map(({ id, title, learnosityItemReference }) => {
            const indentifier = `${learnosityItemReference}:${title.replaceAll(
              '.',
              '',
            )}`;
            const questionSetting = Object.keys(settingsFormState[indentifier]);
            const questionNumber = questionSetting[0].match(/\d+/);
            const questionTittle = `Q${questionNumber} ${title}`;
            const titleRef = createRef();
            const onMouseMove = () => {
              const updatePositionFunction = (event) => {
                titleRef.current.style.top = `${event.clientY + 15}px`;
                titleRef.current.style.left = `${event.clientX + 15}px`;
              };
              return (event) => {
                event.persist();
                updatePositionFunction(event);
              };
            };

            return (
              <li key={id} className="PrintSettings__question-config">
                <div
                  className="PrintSettings__question-title"
                  onMouseMove={onMouseMove}
                >
                  <span className="PrintSettings__question-title--truncated-title">
                    {truncate(questionTittle)}
                  </span>
                  {questionTittle.length > 120 && (
                    <div
                      ref={titleRef}
                      className="PrintSettings__question-title--full-title-wrapper"
                    >
                      <span className="PrintSettings__question-title--full-title">
                        {questionTittle}
                      </span>
                    </div>
                  )}
                </div>
                {questionSetting.map((part) => {
                  const questionPageArea = get(settingsFormState, [
                    indentifier,
                    part,
                    'essayPageArea',
                  ]);
                  const essayLineHeight = get(settingsFormState, [
                    indentifier,
                    part,
                    'essayLineHeight',
                  ]);
                  return (
                    <div
                      key={part}
                      className={cn('PrintSettings__part-wrapper')}
                    >
                      <FormSection name="frqSettings">
                        {part.includes('(') && (
                          <span className="PrintSettings__part">
                            {part.replace(/\d/g, 'Response ')}
                          </span>
                        )}
                        <div className="PrintSettings__question-space-wrapper">
                          <span>
                            {psMultipageFrqResponses
                              ? 'Pages for response'
                              : 'Percent of page'}
                          </span>
                          <Field
                            name={`${indentifier}.${part}.essayPageArea`}
                            component={AutocompleteSelectField}
                            props={{
                              selectOptions: {
                                className: psMultipageFrqResponses
                                  ? 'PrintSettings__dropdown-selection-multi'
                                  : 'PrintSettings__dropdown-selection',
                                options: PAGE_PERCENT_OPTIONS.options,
                                value: getFieldOption(
                                  PAGE_PERCENT_OPTIONS,
                                  questionPageArea,
                                ),
                                disableDropdown: false,
                                disableAutoFocus: true,
                                menuRef: dropdownRef,
                                inputClassName: psMultipageFrqResponses
                                  ? 'autocomplete_input_multi'
                                  : 'autocomplete_input',
                                containerRef,
                                openOnClick: true,
                                useDefaultSelect: true,
                                itemStringMaxLength:
                                  PAGE_PERCENT_OPTIONS.options[0].label.length,
                              },
                            }}
                          />
                        </div>
                        <div className="PrintSettings__lined-config-wrapper">
                          <span>Lined?</span>
                          <Field
                            name={`${indentifier}.${part}.essayLineHeight`}
                            component={SwitchField}
                            props={{
                              otherProps: {
                                states: {
                                  on: {
                                    icon: 'switch-on',
                                    iconClassName:
                                      'PrintSettings__switch-icon PrintSettings__switched-on',
                                  },
                                  off: {
                                    icon: 'switch-off',
                                    iconClassName:
                                      'PrintSettings__switch-icon PrintSettings__switched-off',
                                  },
                                },
                                className: 'PrintSettings__toggle-button',
                                value: getFieldOption(
                                  QUESTION_LINED_OPTIONS,
                                  essayLineHeight,
                                ).label,
                                'data-test-lock-unlock': 'on',
                                disabled: false,
                              },
                            }}
                          />
                        </div>
                      </FormSection>
                    </div>
                  );
                })}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

const selector = formValueSelector('frqPrintSettings');

export default compose(
  connect((state, props) => ({
    initialValues: {
      frqSettings: mapQuestionToSetting(
        props.questions,
        props.assignmentQuestionSettings,
      ),
    },
    settingsFormState: selector(state, 'frqSettings'),
    psMultipageFrqResponses: state.featureFlag.ps_multipage_frq_responses,
  })),
  reduxForm({
    form: 'frqPrintSettings',
    destroyOnUnmount: false,
  }),
)(FRQPrintSetting);
